import React from 'react'
import { PropTypes } from 'prop-types'
import { Link } from '../../../../index'

export default function LinkItem({ itemData }) {
  const { url, title: name, description } = itemData

  return (
    <li className="header__search-results-item">
      <Link className="search__results-item-link" href={url}>
        <img className="d-block" src="/assets/images/tags_20.png" alt="" />
        <div className="search__results-item-info">
          <div className="search__results-item-name">{name}</div>
          <div className="search__results-item-description">{description}</div>
        </div>
      </Link>
    </li>
  )
}

LinkItem.propTypes = {
  itemData: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
}
